import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';

import { useObservable } from 'shared/hooks';
import { UiControlPropsType } from 'shared/types';
import { VmMedia } from 'shared/viewmodels';
import { MediaTemporaryModel } from 'shared/models';

import './styles.scss';

type PropsType = UiControlPropsType<(string | MediaTemporaryModel)[]>;

export const UiMediaUpload = observer(function UiMediaUpload({
    onChange = () => undefined,
    value = [],
}: PropsType) {
    const ref = useRef<HTMLDivElement>(null);
    const store = useObservable({
        isDropping: false,
        dragEnterTimestamp: 0,
        isDroppingTimestamp: false,
        filesToUpload: [] as File[],
    });

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        //window file drag n drop
        const handleDragEnter = () => {
            store.update({
                isDropping: true,
                dragEnterTimestamp: Date.now(),
            });
        };

        const handleDragLeave = () => {
            // довольно багованная реализация, если dragleave тригеррится сразу после dragenter то это фальшивое событие,
            if (Date.now() - store.dragEnterTimestamp > 5) {
                store.set('isDropping', false);
            }
        };
        window.addEventListener('dragenter', handleDragEnter);
        window.addEventListener('dragleave', handleDragLeave);
        return () => {
            window.removeEventListener('dragenter', handleDragEnter);
            window.removeEventListener('dragleave', handleDragLeave);
        };
    }, [ref, store]);

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (!e.dataTransfer?.files?.length) {
            return;
        }
        store.set('filesToUpload', [...store.filesToUpload, ...Array.from(e.dataTransfer.files)])
        store.set('isDropping', false);
    };

    return (
        <div ref={ref} className="ui-new-media-upload">
            {store.isDropping && (
                <div
                    className="ui-new-media-upload__overlay"
                    onDragOver={(event) => event.preventDefault()}
                    onDrop={handleDrop}
                />
            )}
            <input
                type="file"
                value={''}
                onChange={(e) => {
                    store.set('filesToUpload', [...store.filesToUpload, ...Array.from(e.target.files || [])]);
                }}
            />
            {value.map(media => {
                if(typeof media === 'string') {
                    return (
                        <VmMedia
                            key={media}
                            src={media}
                        />
                    )
                }

                return (
                    <VmMedia
                        key={media.id}
                        src={media.url}
                    />
                )
            })}
            {store.filesToUpload.map(file => (
                <VmMedia
                    key={file.lastModified + file.name}
                    fileToUpload={file}
                    onUploaded={() => {

                    }}
                />
            ))}
        </div>
    );
});
